import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22theme.jsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../public/fonts/encode-sans/EncodeSans-VariableFont_wdth,wght.ttf%22,%22style%22:%22normal%22,%22fallback%22:[%22Arial%22,%22sans-serif%22]}],%22variableName%22:%22fontEncodeSans%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'fontEncodeSans', 'fontEncodeSans Fallback', Arial, sans-serif",
        fontStyle: "normal",

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
